<div class="content">
    <div class="message">
        <img src="https://www.medsoft.pl/wp-content/uploads/2015/11/dyrektorek_white.png" class="man">
        <div class="text">
            <div class="error-code">404</div>
            <div>Strona, której szukasz, nie istnieje</div>
        </div>
    </div>
</div>